import { loadModules } from 'esri-loader';
import { LINK_MAPS } from 'src/util/Util';
import i18n from 'src/i18n';

class MapService {
  static loadBaseMap(
    nameKml,
    scope,
    showMeasurement = false,
    layersList = false,
    mapRef = null,
    points = null,
    zoom = null,
    sickPerimeter = null,
    showExtraIcons = true,
    color = '',
    disease_name = ''
  ) {
    loadModules(
      [
        'esri/Map',
        'esri/views/MapView',
        'esri/Graphic',
        'esri/geometry/Point',
        'esri/symbols/PictureMarkerSymbol',
        'esri/layers/KMLLayer',
        'esri/widgets/ScaleBar',
        'esri/widgets/Fullscreen',
        'esri/widgets/BasemapGallery',
        'esri/widgets/Expand',
        'esri/widgets/Home',
        'esri/widgets/Print',
        'esri/widgets/Measurement',
        'esri/widgets/Sketch',
        'esri/layers/GraphicsLayer',
        'esri/widgets/LayerList',
        'esri/layers/FeatureLayer',
        'esri/intl',
      ],
      { css: true }
    )
      .then(
        ([
          Map,
          MapView,
          Graphic,
          Point,
          PictureMarkerSymbol,
          KMLLayer,
          ScaleBar,
          Fullscreen,
          BasemapGallery,
          Expand,
          Home,
          Print,
          Measurement,
          Sketch,
          GraphicsLayer,
          LayerList,
          FeatureLayer,
          intl,
        ]) => {
          intl.setLocale(i18n.locale.toLowerCase());
          const measurement = new Measurement();
          let view;
          if (showMeasurement) {
            var graphicsLayer = new GraphicsLayer({
              title: i18n.t('uti.mixinArcgisMap.graphicsLayer'),
            });
          }

          if (mapRef == null) {
            mapRef = scope.$refs.map;
            mapRef = mapRef[0] ? mapRef[0] : mapRef;
          }

          if (nameKml) {
            const layers = Array.isArray(nameKml)
              ? nameKml.map(
                  (element) =>
                    new KMLLayer({
                      url: LINK_MAPS + element + '/Perimetro.kml',
                    })
                )
              : [new KMLLayer({ url: LINK_MAPS + nameKml + '/Perimetro.kml' })];

            view = new Map({
              basemap: 'hybrid',
              layers,
            });
          } else {
            const basemap = 'hybrid';
            view = new Map({
              basemap,
              layers: showMeasurement ? [graphicsLayer] : [],
            });
          }

          if (points && Array.isArray(points)) {
            scope.center = this.getCenterExtend(points);
          }

          scope.map = new MapView({
            container: mapRef,
            map: view,
            zoom: zoom ? zoom : 14,
            center: [scope.center.lng, scope.center.lat],
          });

          if (layersList) {
            scope.map.ui.add(
              new Expand({
                view: scope.map,
                content: new LayerList({
                  view: scope.map,
                }),
              }),
              'top-right'
            );
          }

          if (showMeasurement) {
            scope.map.ui.add(
              new Expand({
                expandIconClass: 'esri-icon-sketch-rectangle',
                view: scope.map,
                content: new Sketch({
                  layer: graphicsLayer,
                  view: scope.map,
                  creationMode: 'update',
                }),
              }),
              'top-right'
            );

            let activeView = scope.map;
            if (showExtraIcons) {
              const distanceButton = document.getElementById('distance');
              const areaButton = document.getElementById('area');
              const clearButton = document.getElementById('clear');

              distanceButton.addEventListener('click', function () {
                const type = activeView.type;
                measurement.activeTool =
                  type.toUpperCase() === '2D' ? 'distance' : 'direct-line';
                distanceButton.classList.add('active');
                areaButton.classList.remove('active');
              });

              areaButton.addEventListener('click', function () {
                measurement.activeTool = 'area';
                distanceButton.classList.remove('active');
                areaButton.classList.add('active');
              });

              clearButton.addEventListener('click', function () {
                distanceButton.classList.remove('active');
                areaButton.classList.remove('active');
                measurement.clear();
              });

              measurement.view = activeView;
              scope.map.ui.add(measurement, 'top-right');
            }
          }

          if (points && Array.isArray(points)) {
            points.forEach((element) => {
              scope.map.graphics.add(
                new Graphic({
                  geometry: {
                    type: 'point',
                    longitude: element.lng,
                    latitude: element.lat,
                  },
                  symbol: {
                    type: 'simple-marker',
                    color:
                      element.color != (undefined || null)
                        ? element.color
                        : [226, 119, 40],
                    outline: {
                      color: [255, 255, 255],
                      width: 1.3,
                    },
                  },
                  popupTemplate: {
                    title: `<b>  ${
                      element.name ? element.name : disease_name
                    }<b>`,
                    style: {
                      width: '300px',
                      backgroundColor: '#D6EAF8',
                      border: '2px solid #707070',
                      borderRadius: '4px',
                      boxShadow: '1px 1px 2px gray',
                    },
                  },
                })
              );
            });

            if (sickPerimeter) {
              const polygon = {
                type: 'polygon',
                rings: [],
              };

              sickPerimeter.forEach((coord) => {
                let splited = coord.split(',');
                polygon.rings.push(splited);
              });

              polygon.rings.push(sickPerimeter[0].split(','));
              const polylineGraphic = new Graphic({
                geometry: polygon,
              });
              const renderer = {
                type: 'simple',
                symbol: {
                  color: [255, 255, 255, 0],
                  type: 'simple-fill',
                  outline: {
                    style: 'solid',
                    color:
                      color != (undefined || null) ? color : [226, 119, 40],
                    width: 3,
                  },
                },
              };

              let feature = new FeatureLayer({
                title: `${'perimetro'}`,
                source: [polylineGraphic],
                renderer: renderer,
                fields: [
                  {
                    name: 'ObjectID',
                    alias: 'ObjectID',
                    type: 'oid',
                  },
                  {
                    name: 'place',
                    alias: 'Place',
                    type: 'string',
                  },
                ],
                objectIdField: 'ObjectID',
                geometryType: 'polygon',
              });

              view.add(feature);
            }
          } else {
            scope.map.graphics.add(
              new Graphic(
                new Point(scope.center.lng, scope.center.lat),
                new PictureMarkerSymbol(
                  '/static/img/iconos/location-pointer.svg',
                  30,
                  30
                )
              )
            );
          }

          scope.map.ui.add(
            new Fullscreen({
              view: scope.map,
              element: mapRef,
            }),
            'top-left'
          );

          scope.map.ui.add(
            new ScaleBar({
              view: scope.map,
              unit: 'dual',
            }),
            'bottom-left'
          );

          scope.map.ui.add(
            new Expand({
              view: scope.map,
              content: new BasemapGallery({
                view: scope.map,
              }),
            }),
            'top-left'
          );

          scope.map.ui.add(
            new Home({
              view: scope.map,
            }),
            'top-left'
          );

          scope.map.ui.add(
            new Expand({
              view: scope.map,
              content: new Print({
                view: scope.map,
                printServiceUrl:
                  'https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task',
                templateOptions: {
                  legendEnabled: false,
                },
              }),
            }),
            'top-left'
          );

          this.removeLayerUntitled();
        }
      )
      .catch((err) => {
        console.log(err);
      });
  }

  static removeLayerUntitled() {
    setTimeout(() => {
      const layerListItems = document.querySelectorAll(
        '.esri-layer-list__item-title'
      );

      for (const element of layerListItems) {
        const ariaLabel = element.getAttribute('aria-label');
        if (
          ariaLabel === 'Capa de gráficos' ||
          ariaLabel === 'Untitled layer'
        ) {
          element.closest('.esri-layer-list__item').remove();
          break;
        }
      }
    }, 500);
  }

  static getCenterExtend(pts, calculate = true) {
    let totalLat = 0;
    let totalLng = 0;
    const latExtremes = [];
    const lngExtremes = [];

    pts.forEach((point) => {
      totalLat += point.lat * 1;
      totalLng += point.lng * 1;
      latExtremes.push(point.lat);
      lngExtremes.push(point.lng);
    });

    if (calculate) {
      const center = {
        lat: totalLat / pts.length,
        lng: totalLng / pts.length,
      };

      return center;
    } else {
      const maxLat = Math.max(...latExtremes);
      const maxLng = Math.max(...lngs);

      return { lat: maxLat, lng: maxLng };
    }
  }
}

export default MapService;
